import { render, staticRenderFns } from "./ActorMessageConfirm.vue?vue&type=template&id=682b51e6"
import script from "./ActorMessageConfirm.vue?vue&type=script&lang=js"
export * from "./ActorMessageConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports